// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__38Srw","errors":"Errors_errors__2EJBj"};